import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Lead } from '../../model/leads.model';
import GenericInfo, { InfoField } from '../adminScreen/GenericInfo';
import { updateLead } from '../../Redux/Leads/leadsAction';
import Swal from 'sweetalert2';
import { updateLeadChanges } from "../../api/leads.api"
import { setAllLeads } from "../../Redux/Leads/leadsAction"
import { deleteLead } from "../../api/leads.api"
interface LeadInfoViewProps {
  selectedLead: Lead;
  refresh: any
  onClose?: () => void
}

const LeadInfoView: React.FC<LeadInfoViewProps> = ({ selectedLead, refresh, onClose }) => {
  const dispatch = useDispatch();
  const [currentLead, setCurrentLead] = useState<Lead | null>(null);
  const leads = useSelector((state: { leads: { allLeads: Lead[] } }) => state.leads.allLeads);
  useEffect(() => {
    setCurrentLead(selectedLead);
  }, [selectedLead]);
  const formatDateForInput = (dateStr: Date | string): string => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return '';
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // חודשים מתחילים מ-0
    const year = date.getFullYear();
    return `${day}/${month}/${year}`; // רק תאריך בפורמט DD-MM-YYYY


  };
  const convertFromInputDateValue = (yyyymmdd: string): string => {
    if (!yyyymmdd || typeof yyyymmdd !== 'string') return '';
    const parts = yyyymmdd.split('-');
    if (parts.length !== 3) return '';
    const [year, month, day] = parts;
    if (!day || !month || !year) return '';
    return `${day}/${month}/${year}`;
  };
  const handleFieldsUpdate = (updatedFields: InfoField[]) => {
    if (!currentLead) return;

    const updatedLead = { ...currentLead };
    updatedFields.forEach(field => {
      if (field.fieldName) {
        updatedLead[field.fieldName] = field.value;
      }
    });

    setCurrentLead(updatedLead);
  };

  const onSubmit = async (updatedData: Partial<Lead>) => {
    if (!currentLead) return;
    try {
      onClose()
      const processedData = { ...updatedData };
      const updatedLead = { ...currentLead, ...processedData };
      updatedLead.createdDate = new Date(String(updatedLead.createdDate));
      updatedLead.lastContacted = new Date(String(updatedLead.lastContacted));
      const result = await updateLeadChanges(updatedLead, selectedLead.id);
      setCurrentLead(result.data);
      dispatch(updateLead(result.data));
      Swal.fire({
        title: 'הצלחה!',
        text: 'הליד נשמר בהצלחה',
        icon: 'success',
        confirmButtonText: 'אישור',
      });
      const updatedLeads = leads.map(lead =>
        lead.id === result.data.id ? result.data : lead
      );
      dispatch(setAllLeads(updatedLeads));
      refresh()
    } catch (err) {
      console.error('Error updating lead:', err);

    };
  }

  if (!currentLead) return null;

  const fields: InfoField[] = [
    { label: 'id', fieldName: 'id', value: currentLead.id, editType: 'text' },

    { label: 'שם פרטי', fieldName: 'firstName', value: currentLead.firstName, editType: 'text' },
    { label: 'שם משפחה', fieldName: 'lastName', value: currentLead.lastName, editType: 'text' },
    { label: 'טלפון', fieldName: 'phone', value: currentLead.phone, editType: 'text' },
    { label: 'אימייל', fieldName: 'email', value: currentLead.email, editType: 'text' },
    { label: 'סטטוס', fieldName: 'status', value: currentLead.status, editType: 'text' },
    { label: 'מקור', fieldName: 'source', value: currentLead.source, editType: 'text' },
    { label: 'שם עסק', fieldName: 'businessName', value: currentLead.businessName, editType: 'text' },
    {
      label: 'תאריך יצירה',
      fieldName: 'createdDate',
      value: currentLead.createdDate,
      editType: 'date',
    },
    {
      label: 'תאריך יצירת קשר אחרון',
      fieldName: 'lastContacted',
      value: currentLead.lastContacted,
      editType: 'date',
    },



  ];
  const handleDeleteLead = async () => {
    onClose()
    const result = await Swal.fire({
      title: 'האם אתה בטוח?',
      text: 'לא תוכל לשחזר את הליד הזה לאחר המחיקה!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'מחק',
      cancelButtonText: 'ביטול',
    });
    if (result.isConfirmed && currentLead) {
      try {
        await deleteLead(currentLead.id); // מ- leads.api
        refresh();
        Swal.fire('נמחק!', 'הליד נמחק בהצלחה', 'success');
        const updatedLeads = leads.filter(lead => lead.id !== currentLead.id);
        dispatch(setAllLeads(updatedLeads));
      } catch (error) {
        console.error('מחיקת ליד נכשלה:', error);
        Swal.fire('שגיאה', 'אירעה שגיאה בעת המחיקה', 'error');
      }
    }
  };
  return (
    <div style={{ width: '100%' }}>
      <GenericInfo
        title={`${currentLead.firstName} ${currentLead.lastName}`}
        fields={fields}
        onSubmit={onSubmit}
        onFieldsUpdate={handleFieldsUpdate}
         onDelete={handleDeleteLead}
        dataType="lead"
      />
    </div>
  );
};

export default LeadInfoView;
